import Layout from "../layout";
export default [
  {
    path: "/",
    name: "/",
    redirect: "/index",
    component: Layout,
    children: [
      {
        path: "index",
        name: "Index",
        meta: { title: "首页", icon: "home-wifi-fill" },
        component: () => import("@/views/Home")
      }
      // {
      //   path: "404",
      //   name: "404",
      //   meta: { title: "404", icon: 'emotion-unhappy-line' },
      //   component: () => import("@/views/404")
      // }
    ]
  },
  {
    path: "/register",
    component: Layout,
    redirect: "/register/search",
    meta: {
      title: "预注册管理",
      icon: "function-fill",
      permission: [],
      level3: false
    },

    children: [
      {
        path: "search",
        name: "search",
        component: () => import("@/views/Register"),
        meta: {
          title: "预注册用户信息查询",
          permission: []
        }
      }
    ]
  },
  {
    path: "/gather",
    component: Layout,
    redirect: "/gather/manage",
    meta: {
      title: "集结管理",
      icon: "suitcase-line",
      permission: [],
      level3: false
    },
    children: [
      {
        path: "manage",
        name: "manage",
        component: () => import("@/views/dashboard/gather/management"),
        meta: { title: "集结数据管理", permission: [] }
      },
      {
        path: "log",
        name: "log",
        component: () => import("@/views/dashboard/gather/log"),
        meta: { title: "操作日志", permission: [] }
      }
    ]
  },
  {
    path: "/message",
    component: Layout,
    redirect: "/message/search",
    meta: {
      title: "留言管理",
      icon: "message-2-fill",
      permission: [],
      level3: false
    },
    children: [
      {
        path: "search",
        name: "messageSearch",
        component: () => import("@/views/dashboard/message"),
        meta: { title: "留言筛选", permission: [] }
      }
      // {
      //   path: 'detail',
      //   name: 'messageDetail',
      //   component: () => import("@/views/dashboard/message/detail"),
      //   meta: { title: "留言详情", permission: [] },
      // }
    ]
  },
  {
    path: "/event",
    component: Layout,
    redirect: "/event/list",
    meta: {
      title: "定制化管理产品",
      icon: "briefcase-2-line",
      permission: [],
      level3: true
    },
    children: [
      {
        path: "list",
        name: "eventList",
        redirect: "/event/list/gameList",
        component: () => import("@/views/dashboard/event/list"),
        meta: { title: "定制化产品列表", permission: [] },
        children: [
          {
            path: "stencil",
            name: "listStencil",
            meta: { title: "模版配置" },
            component: () => import("@/views/dashboard/event/list/stencil")
          },
          {
            path: "listItem",
            name: "listItem",
            meta: { title: "模版列表" },
            component: () => import("@/views/dashboard/event/list/listItem")
          },
          {
            path: "config",
            name: "listConfig",
            meta: { title: "素材配置" },
            component: () => import("@/views/dashboard/event/list/config")
          },
          {
            path: "rules",
            name: "rulesConfig",
            meta: { title: "配置规则" },
            component: () => import("@/views/dashboard/event/list/rules")
          },
          {
            path: "data",
            name: "dataTable",
            meta: { title: "数据统计" },
            component: () => import("@/views/dashboard/event/list/data")
          },
          {
            path: "gameList",
            name: "gameList",
            meta: { title: "活动列表" },
            component: () => import("@/views/dashboard/event/list/gameCode")
          }
        ]
      }
    ]
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404")
  }
];
